import React from 'react';
import styles from './CaseTag.module.css';

export type CaseTagVariant = 'default' | 'filled' | 'outlined' | 'glass';

interface CaseTagProps {
  label: string;
  variant?: CaseTagVariant;
  className?: string;
}

export const CaseTag: React.FC<CaseTagProps> = ({
  label,
  variant = 'default',
  className,
}) => {
  const variantClass = styles[variant] || '';

  return (
    <span className={`${styles.caseTag} ${variantClass} ${className || ''}`}>
      {label}
    </span>
  );
};
